import(/* webpackMode: "eager", webpackExports: ["SignUpCard"] */ "/vercel/path0/src/app/features/auth/components/SignUpCard.tsx");
